<script setup lang="ts">
const { size = "medium" } = defineProps<{
  size?: "small" | "medium" | "lage";
}>();

const classObject = computed(() => ({
  [`is-${size}`]: size,
}));
</script>

<template>
  <div class="powered-by" :class="classObject">
    <span class="text">Powered by</span>
    <a href="https://wijsneus.ai" class="logo" target="_blank"></a>
  </div>
</template>

<style lang="scss" scoped>
.powered-by {
  display: flex;
  align-items: center;
  gap: 0.3em;
  font-size: 0.9rem;

  &.is-small {
    font-size: 0.8rem;
  }

  &.is-medium {
    font-size: 0.9rem;
  }

  &.is-large {
    font-size: 1rem;
  }
}

.text {
  opacity: 0.5;
}

.logo {
  width: 6.1em;
  height: 1em;
  background-color: currentColor;
  color: currentColor;
  mask-image: url("@/assets/images/wijsneus.svg");
  mask-repeat: no-repeat;
  mask-size: contain;
  margin-top: 0.1em;
}
</style>
